import { render, staticRenderFns } from "./BLESetting.vue?vue&type=template&id=b5bf82cc&"
import script from "./BLESetting.vue?vue&type=script&lang=ts&"
export * from "./BLESetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports